import { render } from "./UpdateTopicComponent.vue?vue&type=template&id=65a443a6&scoped=true"
import script from "./UpdateTopicComponent.vue?vue&type=script&lang=js"
export * from "./UpdateTopicComponent.vue?vue&type=script&lang=js"

import "./UpdateTopicComponent.vue?vue&type=style&index=0&id=65a443a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a443a6"]])

export default __exports__